import CardWrapper from './CardWrapper.style';

export default CardWrapper;
